export default {
  name: 'footer-help',
  label: {
    title: '页脚帮助',
    icon: require('@/assets/icon-component-label_FooterHelp.svg'),
    limit: 1
  },
  sort: 1004
}
